import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { ReactNode } from 'react';
import { DocumentEditor } from 'components/organisms/document-editor/document-editor';
import {
  MeetingPageThinkingLogs,
  type MeetingPageThinkingLogsProps,
} from 'components/pages/meeting-page-template/meeting-page-thinking-log-row';
import { LoaderStreamingComponent } from './loader-streaming';
import {
  BackButton,
  HeaderContainer,
  PreviewContainer,
  PreviewContent,
  PreviewTitle,
} from './preview-styled-components';

interface SectionPreviewProps {
  title: string;
  isLoading: boolean;
  isInitializingStream: boolean;
  streaming?: boolean;
  content: any;
  /** Page-generation thinking row (e.g. meeting section preview). */
  thinkingLogs?: MeetingPageThinkingLogsProps;
  onBack?: () => void;
  onInitialization: (editor: any) => void;
  headerActions?: ReactNode;
}

export const SectionPreview: React.FC<SectionPreviewProps> = ({
  title,
  isLoading,
  content,
  thinkingLogs,
  onBack,
  onInitialization,
  headerActions,
}) => {
  return (
    <PreviewContainer>
      <HeaderContainer>
        {onBack && (
          <BackButton onClick={onBack}>
            <FontAwesomeIcon icon={faArrowLeft} size="sm" />
          </BackButton>
        )}
        <PreviewTitle>{title}</PreviewTitle>
        {headerActions}
      </HeaderContainer>
      <PreviewContent>
        {isLoading ? (
          <LoaderStreamingComponent />
        ) : (
          content && (
            <div>
              {thinkingLogs && (
                <div style={{ marginBottom: 'var(--spacing-05)' }}>
                  <MeetingPageThinkingLogs
                    descriptions={thinkingLogs.descriptions}
                    isStreaming={thinkingLogs.isStreaming}
                    completedSummaryLabel={thinkingLogs.completedSummaryLabel}
                  />
                </div>
              )}
              <DocumentEditor
                onInitialize={onInitialization}
                value={content}
                readonly={true}
              />
            </div>
          )
        )}
      </PreviewContent>
    </PreviewContainer>
  );
};
